/**
 * Medal math (spec 6.1). Times at or under the threshold earn the medal;
 * "author" is the developer's aspirational time, shown beyond gold.
 */
import type { MedalTimes } from "../track/types";

export type Medal = "author" | "gold" | "silver" | "bronze";

const ORDER: Medal[] = ["author", "gold", "silver", "bronze"];

export function medalFor(timeMs: number, medals: MedalTimes): Medal | null {
  for (const m of ORDER) {
    if (timeMs <= medals[m]) return m;
  }
  return null;
}

/** The next medal above the given time, and how far away it is. */
export function nextMedalDelta(
  timeMs: number,
  medals: MedalTimes,
): { medal: Medal; deltaMs: number } | null {
  for (let i = ORDER.length - 1; i >= 0; i--) {
    const m = ORDER[i]!;
    if (timeMs > medals[m]) {
      // find the tightest medal still above this time
      for (let j = i; j >= 0; j--) {
        const cand = ORDER[j]!;
        if (timeMs > medals[cand]) return { medal: cand, deltaMs: timeMs - medals[cand] };
      }
    }
  }
  return null; // already at author pace
}

export const MEDAL_ICONS: Record<Medal, string> = {
  author: "★",
  gold: "●",
  silver: "●",
  bronze: "●",
};
